import React from 'react';

import { SSRBaseGrid } from '../ssr-base-grid';
import {
  RequestNumberColumn,
  OrderNumberColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  AmountColumn,
  StoreIconColumn,
  TrackingNumberColumn,
  CarrierServiceColumn,
  SourceColumn,
} from '../../grids/columns';
import { NoProcessingReturnsPlaceholder } from '../../grids/placeholders/no-processing-returns-placeholder';

const columns = [
  RequestNumberColumn,
  StoreIconColumn,
  OrderNumberColumn,
  SourceColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  TrackingNumberColumn,
  CarrierServiceColumn,
  AmountColumn,
];

const viewSpecificFilters: any[] = []; // oxlint-disable-line @typescript-eslint/no-explicit-any

export const SSRProcessingGrid = () => {
  return (
    <SSRBaseGrid columns={columns} noResultsPlaceholder={<NoProcessingReturnsPlaceholder />} viewSpecificFilters={viewSpecificFilters} />
  );
};
